// Vendor Libs
import React, {useContext} from 'react';
import PropTypes from 'prop-types';

// Material UI
import CategoryIcon from '@material-ui/icons/Category';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import FolderIcon from '@material-ui/icons/Folder';
import MenuIcon from '@material-ui/icons/Menu';
import MovieIcon from '@material-ui/icons/Movie';
import SettingsEthernetIcon from '@material-ui/icons/SettingsEthernet';
import StorefrontIcon from '@material-ui/icons/Storefront';
import {CssBaseline, Divider, List, ListItem, ListItemIcon, ListItemText} from '@material-ui/core';
import {makeStyles} from '@material-ui/core/styles';

// Dish Tech React
import {CheckAuthSession} from '@dishtech-react/core';
import {GetRippleRoles, areRolesAuthorized} from '@dishtech-react/utils';

// Components
import Content from '../nav/content';
import Footer from '../nav/footer';
import Header from '../nav/header';
import Nav from '../nav/nav';
import Root from '../nav/root';

// Contexts
import {RouteContext} from '../../../contexts/route-context';

const useStyles = makeStyles(theme => ({
  root: {
    minHeight: '100vh',
  },
  list: {
    paddingTop: '0px',
  },
  toolbar: theme.mixins.toolbar,
}));

const config = {
  navAnchor: 'left',
  navVariant: 'persistent',
  navWidth: 200,
  collapsible: true,
  collapsedWidth: 64,
  clipped: true,
  headerPosition: 'sticky',
  squeezed: true,
  footerShrink: true,
};

const MainNav = ({children}) => {
  const classes = useStyles();
  const {push} = useContext(RouteContext);
  const rippleRoles = GetRippleRoles();

  return (
    <Root className={classes.root} config={config}>
      <CheckAuthSession />

      <CssBaseline />
      <Header
        menuIcon={{
          inactive: <MenuIcon />,
          active: <ChevronLeftIcon />,
        }}
      >
        {/* header goes here */}
      </Header>
      <Nav
        collapsedIcon={{
          inactive: <ChevronLeftIcon />,
          active: <ChevronRightIcon />,
        }}
        header={
          // provide fixed header inside nav
          // change _ctx -> headerContext and null to some react element
          _ctx => null
        }
      >
        <div className={classes.toolbar} />
        <div>
          <List className={classes.list}>
            <ListItem
              button={true}
              disabled={!areRolesAuthorized(rippleRoles, 'ASSET', ['READ', 'UPDATE'])}
              onClick={() => push('/assets')}
            >
              <ListItemIcon>
                <MovieIcon />
              </ListItemIcon>
              <ListItemText primary="Assets" />
            </ListItem>
            <Divider />
            <ListItem
              button={true}
              disabled={!areRolesAuthorized(rippleRoles, 'FOLDER', ['CREATE', 'DELETE', 'READ', 'UPDATE'])}
              onClick={() => push('/folders')}
            >
              <ListItemIcon>
                <FolderIcon />
              </ListItemIcon>
              <ListItemText primary="Featured Folders" />
            </ListItem>
            <Divider />
            <ListItem
              button={true}
              disabled={!areRolesAuthorized(rippleRoles, 'GENRE', ['CREATE', 'DELETE', 'READ'])}
              onClick={() => push('/genres')}
            >
              <ListItemIcon>
                <CategoryIcon />
              </ListItemIcon>
              <ListItemText primary="Genres" />
            </ListItem>
            <Divider />
            <ListItem
              button={true}
              disabled={!areRolesAuthorized(rippleRoles, 'NETWORK', ['CREATE', 'DELETE', 'READ', 'UPDATE'])}
              onClick={() => push('/networks')}
            >
              <ListItemIcon>
                <SettingsEthernetIcon />
              </ListItemIcon>
              <ListItemText primary="Networks" />
            </ListItem>
            <Divider />
            <ListItem
              button={true}
              disabled={!areRolesAuthorized(rippleRoles, 'STOREFRONT', ['CREATE', 'DELETE', 'READ', 'UPDATE'])}
              onClick={() => push('/storefronts')}
            >
              <ListItemIcon>
                <StorefrontIcon />
              </ListItemIcon>
              <ListItemText primary="Storefronts" />
            </ListItem>
            <Divider />
          </List>
        </div>
      </Nav>
      <Content>{children}</Content>
      <Footer>{/* footer goes here */}</Footer>
    </Root>
  );
};

MainNav.propTypes = {
  children: PropTypes.node,
};

export default MainNav;
